import { useContext } from 'react';
import { Context } from '../_util/Provider';

const useProps = () => {
    const params = useContext(Context);
    return params;
};

export default useProps;
